import { Component, OnInit, SecurityContext } from '@angular/core'
import { FormGroup, FormControl } from '@angular/forms'
import { LaunchDialogService } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { SavedCartService } from './saved-cart.service'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { SAVEDCART_TABLE } from './saved-cart'
import { SHAREDCART_TABLE } from './shared-cart'
import { SAVED_QUOTECART_TABLE } from './saved-quote-cart'
import { SHARED_QUOTECART_TABLE } from './shared-quote-cart'
import { DatePipe } from '@angular/common'
import { DomSanitizer } from '@angular/platform-browser'
import { Router } from '@angular/router'
import { HttpParams } from '@angular/common/http'
import { filter, take } from 'rxjs/operators'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../config/dialog.config'
import { CommonService } from '../../../shared/services/common.service'
import { BreadcrumbService } from '../../../shared/components/breadcrumb/breadcrumb.service'
import { UserRoleService } from '../../../shared/services/user-role.service'

export const SORT_OPTIONS = [
  {
    label: 'Date Saved',
    value: 'byDateSaved',
  },
  {
    label: 'Cart Name',
    value: 'byName',
  },
  {
    label: 'ID',
    value: 'byCode',
  },
  {
    label: 'Total',
    value: 'byTotal',
  },
]

@Component({
  standalone: false,
  selector: 'app-saved-cart',
  templateUrl: './saved-cart.component.html',
  styleUrls: ['./saved-cart.component.scss'],
})
export class SavedCartComponent implements OnInit {
  currentUser
  public searchId: string = ''
  public searchText: string
  public searchFilter: boolean
  displayLoader: boolean
  dataSource = []
  dataSource$: Observable<any>
  isSaveCartEmpty = false
  activeCart
  displayMaxSavedCartErrorMsg: boolean = false
  tabsOptions = [
    { label: 'My Carts', key: 'false' },
    { label: 'Shared Carts', key: 'true' },
  ]
  cartOptions = [
    { label: 'My Quote Carts', key: 'false' },
    { label: 'Quote Shared Carts', key: 'true' },
  ]
  savedCartTable = SAVEDCART_TABLE
  savedCartList: any[] = []
  sharedCartTable = SHAREDCART_TABLE
  sharedCartList: any[] = []
  savedQuoteCartTable = SAVED_QUOTECART_TABLE
  savedQuoteCartList: any[] = []
  sharedQuoteCartTable = SHARED_QUOTECART_TABLE
  sharedQuoteCartList: any[] = []
  constructor(
    private commonService: CommonService,
    protected launchDialogService: LaunchDialogService,
    private breadCrumbService: BreadcrumbService,
    private savedCartService: SavedCartService,
    private globalMessageService: GlobalMessageService,
    private datepipe: DatePipe,
    private domSanitizer: DomSanitizer,
    private router: Router,
    private userRoleService: UserRoleService
  ) {}

  savedCartForm: FormGroup

  sortOptions = SORT_OPTIONS
  sortBy = this.sortOptions[0].value
  sharedCart
  quoteSharedCart
  quoteCart = false
  allowedPermissionFlag: number
  quotePermission = false
  buyCartPermission = false

  ngOnInit() {
    this.isSaveCartEmpty = false
    this.sharedCart = this.tabsOptions[0].key
    this.quoteSharedCart = this.cartOptions[0].key
    this.savedCartForm = new FormGroup({
      sortBy: new FormControl(null),
    })
    this.dataSource = []

    this.commonService.getUserData().subscribe(
      (user) => {
        this.currentUser = user
        //this.loadCartData(); // BHI-23369740 this function is commented due
        // to persona access requirement based on roles assigned to user
        this.accessPersona()
      },
      (err) => {
        this.globalMessageService.add(
          err,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
    this.savedCartService.maxSavedCartErrorNotification.subscribe(
      (data) => {
        this.displayMaxSavedCartErrorMsg = data
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  accessPersona() {
    this.userRoleService.userRoleInfo.subscribe((userRoles) => {
      if (userRoles['quotabilityFlag'] && userRoles['sellabilityFlag']) {
        this.quotePermission = false
        this.buyCartPermission = false
        this.allowedPermissionFlag = 0
        this.loadCartData()
      } else if (userRoles['sellabilityFlag']) {
        this.quotePermission = true
        this.buyCartPermission = false
        this.allowedPermissionFlag = 0
        this.quoteCart = false
        this.loadCartData()
      } else if (userRoles['quotabilityFlag']) {
        this.quotePermission = false
        this.buyCartPermission = true
        this.allowedPermissionFlag = 1
        this.quoteCart = true
        this.loadQuoteCartData()
      }
    })
  }
  keyUp(search, event) {
    if (event.keyCode === 13) {
      this.searchFilter = true
      this.searchText = search
      this.searchId = search.trim()
      if (this.quoteCart) {
        this.loadQuoteCartData(this.searchId)
      } else if (!this.quoteCart) {
        this.loadCartData(this.searchId)
      }
    }
  }

  modelChange(search) {
    this.searchFilter = true
    this.searchText = search
    this.searchId = search.trim()
    if (this.quoteCart) {
      this.loadQuoteCartData(this.searchId)
    } else if (!this.quoteCart) {
      this.loadCartData(this.searchId)
    }
  }

  clearSearchFilter() {
    this.searchText = null
    this.searchFilter = false
    if (this.quoteCart) {
      this.loadQuoteCartData()
    } else if (!this.quoteCart) {
      this.loadCartData()
    }
  }

  loadCartData(searchId?) {
    if (!this.currentUser.uid) {
      return
    }
    let url
    let params = new HttpParams()
    this.displayLoader = true
    this.activeCart = true
    if (searchId) {
      const urlparams = ['users', this.currentUser.uid, 'searchSavedCarts']
      url = this.commonService.constructUrl(urlparams)
      params = params.append('savedCartsOnly', 'true')
      params = params.append('fields', 'FULL')
      params = params.append('pageSize', '3000')
      params = params.append('sort', this.sortBy)
      params = params.append('searchCode', this.searchId)
      params = params.append('searchSharedCarts', this.sharedCart)
      params = params.append('isRfqCart', this.quoteCart)
    } else if (this.sharedCart == 'true') {
      const urlparams = ['users', this.currentUser.uid, 'sharedCarts']
      url = this.commonService.constructUrl(urlparams)
      params = params.append('savedCartsOnly', 'true')
      params = params.append('fields', 'FULL')
      params = params.append('pageSize', '3000')
      params = params.append('sort', this.sortBy)
    } else {
      const urlparams = ['users', this.currentUser.uid, 'carts']
      url = this.commonService.constructUrl(urlparams)
      params = params.append('savedCartsOnly', 'true')
      params = params.append('fields', 'FULL')
      params = params.append('pageSize', '3000')
      params = params.append('sort', this.sortBy)
    }
    this.dataSource$ = this.commonService.getData(url, params)
    this.dataSource$.subscribe(
      (result) => {
        if (result.carts.length > 0) {
          window.scrollTo(0, 0)
          this.dataSource = result.carts

          for (let i = 0; i < this.dataSource.length; i++) {
            let date: any = new Date()
            let expiryDate: any = new Date(this.dataSource[i].expirationTime)
            let diffDate = Math.floor(
              (expiryDate - date) / (1000 * 60 * 60 * 24)
            )
            if (diffDate <= this.dataSource[i].savedCartDaysToExpire) {
              this.dataSource[i].showWarning = true
            } else {
              this.dataSource[i].showWarning = false
            }
          }
          this.isSaveCartEmpty = false
          if (this.sharedCart == 'false') {
            this.savedCartList = result.carts.map((entry: any) => {
              entry.saveTime = this.datepipe.transform(
                entry.saveTime,
                'dd MMM yyyy'
              )
              entry.expirationTime = this.datepipe.transform(
                entry.expirationTime,
                'dd MMM yyyy'
              )
              entry.restoredTime = this.datepipe.transform(
                entry.restoredTime,
                'dd MMM yyyy'
              )
              entry.name = entry.name ? entry.name : ''
              entry.restoredUserName = entry.restoredUserName
                ? entry.restoredUserName
                : ''
              entry.description = entry.description ? entry.description : ''
              entry.estimatedTotal = entry.totalPriceWithTax.formattedValue
              return entry
            })
            this.savedCartTable.payload.data = this.savedCartList
            this.savedCartTable.payload.length = this.savedCartList.length
          } else {
            this.sharedCartList = result.carts.map((entry: any) => {
              entry.saveTime = this.datepipe.transform(
                entry.saveTime,
                'dd MMM yyyy'
              )
              entry.expirationTime = this.datepipe.transform(
                entry.expirationTime,
                'dd MMM yyyy'
              )
              entry.restoredTime = this.datepipe.transform(
                entry.restoredTime,
                'dd MMM yyyy'
              )
              entry.name = entry.name
              entry.restoredUserName = entry.restoredUserName
                ? entry.restoredUserName
                : ''
              entry.estimatedTotal = entry.totalPriceWithTax.formattedValue
              entry.savedByName = entry.savedBy.name
              return entry
            })
            this.sharedCartTable.payload.data = this.sharedCartList
            this.sharedCartTable.payload.length = this.sharedCartList.length
          }
        } else {
          this.dataSource = []
          this.isSaveCartEmpty = true
        }
        this.displayLoader = false
      },
      (err) => {
        this.displayLoader = false
        this.globalMessageService.add(
          err,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
        this.dataSource = []
      }
    )
  }

  loadQuoteCartData(searchId?) {
    if (!this.currentUser.uid) {
      return
    }
    let url
    let params = new HttpParams()
    this.displayLoader = true
    this.activeCart = true
    if (searchId) {
      const urlparams = ['users', this.currentUser.uid, 'searchSavedCarts']
      url = this.commonService.constructUrl(urlparams)
      params = params.append('savedCartsOnly', 'true')
      params = params.append('fields', 'FULL')
      params = params.append('pageSize', '3000')
      params = params.append('sort', this.sortBy)
      params = params.append('searchCode', this.searchId)
      params = params.append('searchSharedCarts', this.quoteSharedCart)
      params = params.append('isRfqCart', this.quoteCart)
    } else if (this.quoteSharedCart) {
      const urlparams = ['users', this.currentUser.uid, 'quoteCarts']
      url = this.commonService.constructUrl(urlparams)
      params = params.append('savedCartsOnly', 'true')
      params = params.append('sharedCarts', this.quoteSharedCart)
      params = params.append('fields', 'FULL')
      params = params.append('pageSize', '3000')
      params = params.append('sort', this.sortBy)
    }

    this.dataSource$ = this.commonService.getData(url, params)
    this.dataSource$.subscribe(
      (result) => {
        if (result.carts.length > 0) {
          window.scrollTo(0, 0)
          this.dataSource = result.carts

          for (let i = 0; i < this.dataSource.length; i++) {
            let date: any = new Date()
            let expiryDate: any = new Date(this.dataSource[i].expirationTime)
            let diffDate = Math.floor(
              (expiryDate - date) / (1000 * 60 * 60 * 24)
            )
            if (diffDate <= this.dataSource[i].savedCartDaysToExpire) {
              this.dataSource[i].showWarning = true
            } else {
              this.dataSource[i].showWarning = false
            }
          }
          this.isSaveCartEmpty = false
          if (this.quoteSharedCart == 'false') {
            this.savedQuoteCartList = result.carts.map((entry: any) => {
              entry.saveTime = this.datepipe.transform(
                entry.saveTime,
                'dd MMM yyyy'
              )
              entry.expirationTime = this.datepipe.transform(
                entry.expirationTime,
                'dd MMM yyyy'
              )
              entry.restoredTime = this.datepipe.transform(
                entry.restoredTime,
                'dd MMM yyyy'
              )
              entry.name = entry.name ? entry.name : ''
              entry.restoredUserName = entry.restoredUserName
                ? entry.restoredUserName
                : ''
              entry.description = entry.description ? entry.description : ''
              entry.estimatedTotal = entry.totalPriceWithTax.formattedValue
              return entry
            })
            this.savedQuoteCartTable.payload.data = this.savedQuoteCartList
            this.savedQuoteCartTable.payload.length =
              this.savedQuoteCartList.length
          } else {
            this.sharedQuoteCartList = result.carts.map((entry: any) => {
              entry.saveTime = this.datepipe.transform(
                entry.saveTime,
                'dd MMM yyyy'
              )
              entry.expirationTime = this.datepipe.transform(
                entry.expirationTime,
                'dd MMM yyyy'
              )
              entry.restoredTime = this.datepipe.transform(
                entry.restoredTime,
                'dd MMM yyyy'
              )
              entry.name = entry.name
              entry.restoredUserName = entry.restoredUserName
                ? entry.restoredUserName
                : ''
              entry.estimatedTotal = entry.totalPriceWithTax.formattedValue
              entry.savedByName = entry.savedBy.name
              return entry
            })
            this.sharedQuoteCartTable.payload.data = this.sharedQuoteCartList
            this.sharedQuoteCartTable.payload.length =
              this.sharedQuoteCartList.length
          }
        } else {
          this.dataSource = []
          this.isSaveCartEmpty = true
        }
        this.displayLoader = false
      },
      (err) => {
        this.displayLoader = false
        this.globalMessageService.add(
          err,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
        this.dataSource = []
      }
    )
  }

  isExpiring(expiryDate: any, daysToExpire: any) {
    const date1 = new Date()
    const date2 = new Date(expiryDate)
    const diffTime = Math.abs(date2.getTime() - date1.getTime())
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    if (diffDays < daysToExpire) {
      return true
    }
    return false
  }

  deleteSavedCart(element) {
    this.openDeleteModal(element)
  }

  private openDeleteModal(element) {
    const componentdata = {
      currentCart: element,
      currentUser: this.currentUser,
    }

    const deleteSavedCartDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.DELETE_SAVED_CART,
      undefined,
      undefined,
      componentdata
    )
    if (deleteSavedCartDialog) {
      deleteSavedCartDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.DELETE_SAVED_CART
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.data?.deleteSuccess) {
            if (this.quoteCart) {
              this.loadQuoteCartData()
            } else if (!this.quoteCart) {
              this.loadCartData()
            }
            window.scrollTo(0, 0)
          }
        })
    }
  }

  restoreSavedCart(element) {
    this.openRestoreModal(element)
  }

  private openRestoreModal(element) {
    const componentdata = {
      currentCart: element,
      currentUser: this.currentUser,
      sharedCartFlag: this.sharedCart,
      quoteCartFlag: this.quoteCart,
    }

    const restoreSavedCartDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.RESTORE_SAVED_CART,
      undefined,
      undefined,
      componentdata
    )
    if (restoreSavedCartDialog) {
      restoreSavedCartDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }
  }
  private openRestoreQuoteModal(element) {
    const componentdata = {
      currentCart: element,
      currentUser: this.currentUser,
      sharedCartFlag: this.quoteSharedCart,
      quoteCartFlag: this.quoteCart,
    }

    const restoreSavedQuoteCartDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.RESTORE_SAVED_QUOTE_CART,
      undefined,
      undefined,
      componentdata
    )
    if (restoreSavedQuoteCartDialog) {
      restoreSavedQuoteCartDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }
  }

  extendExpiry(element) {
    this.extendExpiryModal(element)
  }

  private extendExpiryModal(element) {
    const componentdata = {
      currentCart: element,
      currentUser: this.currentUser,
    }

    const extendExpiryDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.EXTEND_CART_EXPIRY,
      undefined,
      undefined,
      componentdata
    )
    if (extendExpiryDialog) {
      extendExpiryDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.EXTEND_CART_EXPIRY
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.data?.extendedExpiry) {
            if (this.quoteCart) {
              this.loadQuoteCartData()
            } else if (!this.quoteCart) {
              this.loadCartData()
            }
          }
        })
    }
  }

  loadSharedCartData() {
    this.activeCart = false
  }

  public getHeader = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.savedCartTable['header'])
    )
  }
  public getOptions = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.savedCartTable['options'])
    )
  }
  public getSchema = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.savedCartTable['schema'])
    )
  }
  public getPayload = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.savedCartTable['payload'])
    )
  }

  public getSharedHeader = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.sharedCartTable['header'])
    )
  }
  public getSharedOptions = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.sharedCartTable['options'])
    )
  }
  public getSharedSchema = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.sharedCartTable['schema'])
    )
  }
  public getSharedPayload = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.sharedCartTable['payload'])
    )
  }
  public getQuoteHeader = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.savedQuoteCartTable['header'])
    )
  }
  public getQuoteOptions = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.savedQuoteCartTable['options'])
    )
  }
  public getQuoteSchema = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.savedQuoteCartTable['schema'])
    )
  }
  public getQuotePayload = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.savedQuoteCartTable['payload'])
    )
  }

  public getQuoteSharedHeader = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.sharedQuoteCartTable['header'])
    )
  }
  public getQuoteSharedOptions = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.sharedQuoteCartTable['options'])
    )
  }
  public getQuoteSharedSchema = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.sharedQuoteCartTable['schema'])
    )
  }
  public getQuoteSharedPayload = () => {
    return this.domSanitizer.sanitize(
      SecurityContext.NONE,
      JSON.stringify(this.sharedQuoteCartTable['payload'])
    )
  }
  changes(e) {
    let iconText = this.domSanitizer.sanitize(
      SecurityContext.NONE,
      e?.detail?.event?.target?.innerHTML
    )
    let anchorText = this.domSanitizer.sanitize(
      SecurityContext.NONE,
      e?.detail?.event?.target?.localName
    )
    if (iconText == 'date_range') {
      this.extendExpiry(e.detail.items)
    }
    if (iconText == 'shopping_cart_checkout' && !this.quoteCart) {
      this.restoreSavedCart(e.detail.items)
    } else if (iconText == 'shopping_cart_checkout' && this.quoteCart) {
      this.openRestoreQuoteModal(e.detail.items)
    }
    if (iconText == 'delete') {
      this.deleteSavedCart(e.detail.items)
    }
    if (anchorText == 'bh-a' && this.quoteCart) {
      this.router.navigate(['saved-carts', e.detail.itemRaw.code], {
        queryParams: {
          sharedCart: this.quoteSharedCart,
          quoteCart: this.quoteCart,
        },
      })
    } else if (anchorText == 'bh-a' && !this.quoteCart) {
      this.router.navigate(['saved-carts', e.detail.itemRaw.code], {
        queryParams: {
          sharedCart: this.sharedCart,
          quoteCart: this.quoteCart,
        },
      })
    }
  }
  onTabClick(e) {
    this.searchText = null
    this.searchFilter = false
    this.sharedCart = e.detail.key
    this.loadCartData()
  }
  onTabClickQuote(e) {
    this.searchText = null
    this.searchFilter = false
    this.quoteSharedCart = e.detail.key
    this.loadQuoteCartData()
  }

  tabClick(event) {
    this.searchText = null
    this.searchFilter = false
    if (event.index == 0) {
      this.quoteCart = false
      this.loadCartData()
    } else if (event.index == 1) {
      this.quoteCart = true
      this.loadQuoteCartData()
    }
  }
}
